import AppDispatcher from '../../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import _ from 'lodash';
import AccountsApiUtils from '../../utils/AccountsApiUtils';
import AccountConstants from '../../constants/AccountConstants';
import AppConstants, { CHANGE_EVENT } from '../../constants/AppConstants';
import envConfig from '../../../static/config.js';
import ProjectionApiUtils from '../../utils/ProjectionApiUtils';
import { LARGE_CUSTOMER_MIN_ACCOUNTS_SIZE } from '../../constants/LargeCustomerViewConstants';
import { isSavingsPotsActive } from '../../utils/SavingsPotsUtils';
import { isSpendingsEnabled } from '../../utils/SpendingsUtils';
import { isEnrichCapabilityAvailable } from '../../utils/AccountUtils';
import { youthAccountProductCodes } from '../../constants/YouthAccountConstants';
import { ACCOUNT_TYPE_SAVINGS } from '../../constants/AccountConstants';

let accountList = [];
// todo global variable manipulation going on here!
let _accountDetails = []; // eslint-disable-line
let __account = '';
let _termsAndConditionsFlag = false;
let _accountTypeColor = [
  {
    accntId: '',
    accntClass: '',
  },
];
let _load = false;
let _loader = false;
let _showError = false;
let _status = '';
let _error = '';
let _sweepsEnabled = false;
let _stmtPreferenceEnabled = false;
let _potsEnabled = false;
let _spendingsEnabled = false;
let _alertsEnabled = false;
let _managePaymentsEnabled = false;
let _managePayeesEnabled = false;
let _isCreditCardUser = true;
let _sweepsOutEnabled = false;
let _accountData = {};
let _accountsLoaded = false;
let _forMoveMoneyErrorPage = false;
let _paymentsEnabled = false;
let _navigationReference = '';
let _accountReorderErrorFlag = false;
let manageCardEnabled = false;
let manageDebitCardEnabled = false;
let _mtrackProductEnabled = false;

class AccountsStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  getAll() {
    return accountList || [];
  }

  // to get the Account Detail
  getAccountDetail(id) {
    return _.find(accountList, { id }) || {};
  }

  // to get the type of accounts
  getAccountType(id) {
    return _.find(_accountTypeColor, { accntId: id });
  }
  getAccountTypeFromAccountId(id) {
    const account = _.find(accountList, { id }) || {};
    return account.type;
  }
  setAccountID(id) {
    __account = id;
  }
  getAccount() {
    return __account;
  }
  getAccountByAccountNumberSortCode(accountNumber, sortCode) {
    const sortCodeFormatted = sortCode ? sortCode.replace(/-/g, '') : sortCode;
    const account = _.find(accountList, {
      accountNumber,
      sortCode: sortCodeFormatted,
    });
    return account;
  }
  // to get the list of accountIds
  getAccountIdList() {
    const _accounts = [];
    _.map(accountList, (account) => {
      if (account.actionsAvailable['/account/transactions/read']) {
        _accounts.push(account.id);
      }
      return false;
    });
    return _accounts;
  }
  /*
    Get the account list based on the cabapility
    */
  getAllCapableAccounts(capabiltyName) {
    const cabpableAccountList = [];
    _.map(accountList, (account) => {
      if (account.actionsAvailable[capabiltyName]) {
        cabpableAccountList.push(account);
      }
      return false;
    });
    return cabpableAccountList;
  }

  getAllSavingsTypeAccounts() {
    return this.getAll().filter(({ type }) => type === ACCOUNT_TYPE_SAVINGS);
  }

  // to get the terms and conditions for user
  getTermsAndConditions() {
    return _termsAndConditionsFlag;
  }

  getAllSMEPaymentCapableAccounts() {
    return accountList.filter(
      (account) => account.actionsAvailable['/account/payments/uk/default/out']
    );
  }

  SMEHasPaymentCapability() {
    return this.getAllSMEPaymentCapableAccounts().length > 0;
  }

  getALlPaymentCapableAccounts() {
    const paymentCapableAccounts = [];
    _.map(accountList, (account) => {
      if (
        account.actionsAvailable['/account/payments/uk/default/out'] === true
      ) {
        paymentCapableAccounts.push(account);
      }
    });
    return paymentCapableAccounts;
  }

  getAllAccountsForPaymentsHistory() {
    const cabpableAccountList = accountList.filter(
      (account) =>
        account.actionsAvailable['/account/transactions/read'] ||
        account.actionsAvailable['/account/payments/read']
    );
    return cabpableAccountList;
  }

  getDefaultAccountForBeneficiaryCreation() {
    let capableAcc = _.find(
      accountList,
      (capableAcc) =>
        capableAcc.actionsAvailable['/account/payments/uk/default/out']
    );
    return capableAcc;
  }

  updateOrderAndNickname(data) {
    _.map(data.accounts, (account) => {
      let orderAndNameChanged = this.getAccountDetail(account.id);
      _.set(orderAndNameChanged, 'metadata.display_name', account.display_name);
      _.set(orderAndNameChanged, 'displayName', account.display_name);
      if (account.display_order !== 0 && account.display_order !== null) {
        _.set(orderAndNameChanged, 'display_order', account.display_order);
        _.set(
          orderAndNameChanged,
          'metadata.display_order',
          account.display_order
        );
      }
    });
  }

  reSortAccounts() {
    accountList = _.sortBy(accountList, ['display_order']);
  }

  getLoad() {
    return _load;
  }
  getPaymentLoad() {
    return _loader;
  }
  getError() {
    return _error;
  }
  getStatus() {
    return _status;
  }
  getErrorFlag() {
    return _showError;
  }
  getAccounts() {
    return accountList;
  }
  getAlertsFlag() {
    return _alertsEnabled;
  }
  getSweepsFlag() {
    return _sweepsEnabled;
  }
  getSweepsOutFlag() {
    return _sweepsOutEnabled;
  }
  getStmtPreferenceFlag() {
    return _stmtPreferenceEnabled;
  }
  getPotsFlag() {
    return _potsEnabled;
  }
  getSpendingsFlag() {
    return _spendingsEnabled;
  }
  getManagePaymentsFlag() {
    return _managePaymentsEnabled;
  }
  getManagePayeesFlag() {
    return _managePayeesEnabled;
  }
  isCreditCardUser() {
    return _isCreditCardUser;
  }
  getAccountDetailErrorFlag() {
    return _forMoveMoneyErrorPage;
  }
  getAccountsLoadedFlag() {
    return _accountsLoaded;
  }
  getAccountDetailsLoadedFlag(id) {
    const account = _.find(accountList, { id }) || {};
    return _.get(account, 'accountDetails.isLoaded', false);
  }
  getAccountDetailsInError(id) {
    const account = _.find(accountList, { id }) || {};
    return !!_.get(account, 'accountDetails.error', false);
  }
  getNavigationReference() {
    return _navigationReference;
  }
  getPaymentsFlag() {
    return _paymentsEnabled;
  }
  getAccountReorderErrorFlag() {
    return _accountReorderErrorFlag;
  }

  isSingleAccount() {
    return accountList.length === 1;
  }
  isLargeCustomer() {
    return accountList.length >= LARGE_CUSTOMER_MIN_ACCOUNTS_SIZE;
  }
  isManageCardEnabled() {
    return manageCardEnabled;
  }
  isManageDebitCardEnabled() {
    return manageDebitCardEnabled;
  }
  isMTrackProductEnabled() {
    return _mtrackProductEnabled;
  }
  getTotalNumberOfAccounts() {
    return accountList.length;
  }
  getAccountData() {
    return _accountData;
  }
  getAlertsAvailableSingleAccount() {
    const alertSingleAccounts = [];
    _.forEach(accountList, (account) => {
      const isAlertsAvailable =
        account.actionsAvailable['/account/alerts'] ||
        account.actionsAvailable['/account/alerts/transaction/debit'] ||
        account.actionsAvailable['/account/alerts/transaction/credit'];
      if (isAlertsAvailable) {
        alertSingleAccounts.push(account);
      }
    });
    if (alertSingleAccounts.length === 1) {
      return alertSingleAccounts[0].id;
    }
  }
  hasAccountWithViewBalanceCapabilityAsFalse() {
    return (
      accountList.filter(
        (account) =>
          account.actionsAvailable['/account/balance/available'] === false
      ).length > 0 || false
    );
  }
  isEnriched() {
    /**
     * Quite confusing - getAccount() method returns the actual ID
     * rather than details object.
     */
    const accountId = this.getAccount();

    if (!accountId) {
      return false;
    }

    return isEnrichCapabilityAvailable(this.getAccountDetail(accountId));
  }
  isYouthAccount() {
    if (accountList.length > 0) {
      const { product, role } = accountList[0];
      return (
        role === 'OWNER' && youthAccountProductCodes.includes(product.code)
      );
    }
  }
  resetStore() {
    accountList = [];
    _accountDetails = [];
    _termsAndConditionsFlag = false;
    _accountTypeColor = [
      {
        accntId: '',
        accntClass: '',
      },
    ];
    _load = false;
    _showError = false;
    _error = '';
    _status = '';
    _sweepsEnabled = false;
    _stmtPreferenceEnabled = false;
    _potsEnabled = false;
    _spendingsEnabled = false;
    _alertsEnabled = false;
    _managePaymentsEnabled = false;
    _managePayeesEnabled = false;
    _isCreditCardUser = true;
    _sweepsOutEnabled = false;
    _accountsLoaded = false;
    _accountReorderErrorFlag = false;
  }

  setAccountDetailsBalance() {
    accountList.forEach((account) => {
      if (!account.actionsAvailable['/account/read/limited']) {
        account.accountDetails = { balances: account.balances };
      }
    });

    _accountsLoaded = true;

    this.emitChange();
  }

  clearAccountDetailsIsLoaded(id) {
    let index = _.findIndex(accountList, ['id', id]);
    if (index !== -1) {
      _.set(accountList[index], 'accountDetails.isLoaded', false);
    }
  }

  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case AccountConstants.REQUEST_ACCOUNTS_LIST:
        _showError = false;
        _load = false;
        _loader = false;
        AccountsApiUtils.getAccountsList(_termsAndConditionsFlag);
        break;

      case AccountConstants.UPDATE_ACCOUNT_ORDER_AND_NICKNAME:
        this.updateOrderAndNickname(actionData.data);
        break;

      case AccountConstants.RESORT_ACCOUNT:
        this.reSortAccounts();
        this.emitChange();
        break;

      case AccountConstants.REQUEST_ACCOUNTS_LIST_SUCCESS:
        _load = true;
        _showError = false;
        _accountReorderErrorFlag = false;
        if (_termsAndConditionsFlag) {
          _termsAndConditionsFlag = false;
        }

        _accountData = actionData.data;

        accountList = [];
        _.map(_accountData, (account) => {
          if (
            account.actionsAvailable['/account/read'] ||
            account.actionsAvailable['/account/read/limited']
          ) {
            accountList.push(account);
          }
          if (
            (account.actionsAvailable['/account/alerts'] ||
              account.actionsAvailable['/account/alerts/transaction/debit'] ||
              account.actionsAvailable['/account/alerts/transaction/credit']) &&
            !_alertsEnabled
          ) {
            _alertsEnabled = true;
          }
          if (account.actionsAvailable['/account/sweeps'] && !_sweepsEnabled) {
            _sweepsEnabled = true;
          }
          if (account.actionsAvailable['/account/mtrack/access']) {
            _mtrackProductEnabled = true;
          }
          if (
            account.actionsAvailable['/account/sweeps/transfer/out'] &&
            !_sweepsOutEnabled
          ) {
            _sweepsOutEnabled = true;
          }
          if (
            account.actionsAvailable[
              '/account/preferences/paperstatementoptout'
            ] &&
            !_stmtPreferenceEnabled
          ) {
            _stmtPreferenceEnabled = true;
          }
          if (account.actionsAvailable['/account/pots'] && !_potsEnabled) {
            _potsEnabled = true;
          }
          if (
            (account.actionsAvailable['/account/mandates/so/read'] ||
              account.actionsAvailable['/account/mandates/dd/read']) &&
            !_managePaymentsEnabled
          ) {
            _managePaymentsEnabled = true;
          }
          if (
            account.actionsAvailable[
              '/account/beneficiaries/account/readwrite'
            ] &&
            !_managePayeesEnabled
          ) {
            _managePayeesEnabled = true;
          }
          // '/account/payments/transfer/out'
          if (
            isSpendingsEnabled() &&
            (account.type === 'current' || account.type === 'credit_card') &&
            !_spendingsEnabled
          ) {
            _spendingsEnabled = true;
          }
          if (account.type !== 'credit_card' && _isCreditCardUser) {
            _isCreditCardUser = false;
          }
          if (
            account.actionsAvailable['/account/payments/uk/default/out'] ||
            account.actionsAvailable['/account/payments/transfer/out']
          ) {
            _paymentsEnabled = true;
          }
          if (account.actionsAvailable['/users/card/manage']) {
            manageCardEnabled = true;
          }
          if (account.actionsAvailable['/users/debit_card/manage']) {
            manageDebitCardEnabled = true;
          }
          return false;
        });
        if (accountList !== undefined && accountList.length > 0) {
          _.map(accountList, (account, index) => {
            let accountIndex = index + 1;
            accountIndex = accountIndex % 10 === 0 ? 10 : accountIndex % 10;
            _accountTypeColor.push({
              accntId: account.id,
              accntClass: `account-${accountIndex}`,
            });
            if (isSavingsPotsActive() && envConfig.isFinancialStoryEnabled) {
              if (
                account.type === 'current' &&
                account.actionsAvailable['/account/projections']
              ) {
                ProjectionApiUtils.getProjectionSummary(accountList[index].id);
              } else if (accountList[index].actionsAvailable['/account/pots']) {
                AccountsApiUtils.getPotsData(accountList[index].id);
              }
            }
            return false;
          });
        }
        _loader = true;
        this.emitChange();
        break;
      case AccountConstants.REQUEST_ACCOUNT_DETAILS:
        _accountsLoaded = false;
        let index = _.findIndex(accountList, ['id', actionData.data]);
        if (index !== -1) {
          _.set(accountList[index], 'accountDetails.isLoaded', false);
        }
        AccountsApiUtils.getAccountDetails(actionData.data);
        break;

      case AccountConstants.REQUEST_ACCOUNT_DETAILS_SUCCESS:
        index = _.findIndex(accountList, ['id', actionData.data.id]);
        if (index !== -1) {
          accountList[index].accountDetails = actionData.data;
          accountList[index].balances = actionData.data.balances;
          delete accountList[index].accountDetails.balances;
          accountList[index].accountDetails.isLoaded = true;
        }
        _accountsLoaded = true;
        this.emitChange();
        break;
      case AccountConstants.REQUEST_ACCOUNT_DETAILS_ERROR:
        index = _.findIndex(accountList, { id: actionData.id });
        if (index !== -1) {
          accountList[index].accountDetails = actionData.data;
        }
        _accountsLoaded = true;
        this.emitChange();
        break;
      case AccountConstants.REQUEST_TERMS_AND_CONDITIONS:
        _termsAndConditionsFlag = true;
        this.emitChange();
        break;

      case AccountConstants.REQUEST_ACCEPT_TC_SUCCESS:
        _termsAndConditionsFlag = true;
        AccountsApiUtils.getAccountsList(_termsAndConditionsFlag);
        this.emitChange();
        break;

      case AccountConstants.REQUEST_ACCOUNTS_LIST_ERROR:
        accountList = [];
        if (!_.isEmpty(actionData.error)) {
          _error = actionData.error;
        }
        _status = actionData.status;
        _showError = true;
        this.emitChange();
        break;

      case AccountConstants.REQUEST_ACCOUNTS_RESET_ERROR:
        _showError = false;
        this.emitChange();
        break;

      case AccountConstants.REQUEST_DANGER_PERIOD:
        AccountsApiUtils.getProjectionDetails(actionData.data);
        break;

      case AccountConstants.REQUEST_REJIG_POT_DETAILS:
        AccountsApiUtils.getPotsData(actionData.data);
        break;

      case AccountConstants.REQUEST_REJIG_POT_DETAILS_SUCCESS:
        const __index = _.findIndex(accountList, { id: actionData.id });
        if (__index > -1) {
          if (actionData.data.unallocated_amount.value < 0) {
            accountList[__index].setShowIcon(true);
          } else {
            accountList[__index].setShowIcon(false);
          }
        }
        this.emitChange();
        break;

      case AccountConstants.REQUEST_RESET_REJIG_ICON:
        const __indexIcon = _.findIndex(accountList, { id: actionData.id });
        if (__indexIcon > -1) {
          if (actionData.data.unallocated_amount.value < 0) {
            accountList[__indexIcon].setShowIcon(true);
          } else {
            accountList[__indexIcon].setShowIcon(false);
          }
        }
        this.emitChange();
        break;

      case AccountConstants.REQUEST_DANGER_PERIOD_SUCCESS:
        const indexOfAcc = _.findIndex(accountList, { id: actionData.id });
        if (indexOfAcc > -1) {
          if (actionData.data.projection_periods[0].warning_days.length > 0) {
            accountList[indexOfAcc].setShowIcon(true);
          } else {
            accountList[indexOfAcc].setShowIcon(false);
          }
        }
        this.emitChange();
        break;
      case AccountConstants.NAVIGATION_REFERENCE:
        _navigationReference = actionData.data;
        break;
      case AccountConstants.SET_ACCOUNT:
        __account = actionData.id;
        break;
      case AccountConstants.ACCOUNT_REORDER_ERROR:
        _accountReorderErrorFlag = true;
        this.emitChange();
        break;
      case AppConstants.LOGOUT_USER:
        this.resetStore();
        this.emitChange();
        break;
      default:
        break;
    }
  }
}

export default new AccountsStore();
